<div #rootNode class="transport-log" [ngClass]="componentSizeStyle">

  <div [formGroup]="detailsForm">
    <sc-flex>
      @if (allowLogEntryKeySelection) {
        <mat-checkbox name="showLogEntryKeys" formControlName="showLogEntryKeys">
          <sc-dictionary-label
          dictionaryKey="tmc-yard.ui.transport.details.dialog.protocol.action.show-log-entry-keys"></sc-dictionary-label>
        </mat-checkbox>
      }
      <sc-content-spacer grow></sc-content-spacer>
      <sc-action-icon (click)="copyLogToClipboard()" iconClass="fa-copy"></sc-action-icon>
    </sc-flex>
    <div class="log-entry-container-spacer">
      <div class="visible-container"></div>
    </div>
  </div>

  <div class="log-entries text-selection" id="logTable">
    <div class="log-entries-layout">

      <div class="log-entries-container list-heading">
        <div class="routing-container">
          <div class="routing-detail-heading">
            <sc-dictionary-label
            dictionaryKey="tmc-yard.ui.transport.details.dialog.protocol.table.column.position"></sc-dictionary-label>
          </div>
        </div>
        <div class="log-details-container">
          <div class="log-detail-row">
            <div class="log-detail-heading">
              <sc-dictionary-label
              dictionaryKey="tmc-yard.ui.transport.details.dialog.protocol.table.column.transportLog"></sc-dictionary-label>
            </div>
          </div>
        </div>
      </div>

      <div id="log-entries" class="log-entries-scrollable">

        @for (rp of routingPositions; track rp) {
          <div class="log-entries-container">
            <div class="routing-container">
              @if (rp.stationName) {
                <div class="routing-detail">
                  <div class="label">
                    <sc-dictionary-label
                    dictionaryKey="tmc-yard.ui.transport.details.dialog.stationName"></sc-dictionary-label>
                  </div>
                  <sc-content-spacer></sc-content-spacer>
                  <div class="value">{{ rp.stationName}}</div>
                </div>
              }
              @if (rp.cargo) {
                <div class="routing-detail">
                  <div class="label">
                    <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.cargo"></sc-dictionary-label>
                  </div>
                  <sc-content-spacer></sc-content-spacer>
                  <div class="value">{{ rp.cargo}}</div>
                </div>
              }
              @if (rp.positionStatus) {
                <div class="routing-detail">
                  <div class="label">
                    <sc-dictionary-label
                    dictionaryKey="tmc-yard.ui.transport.details.dialog.positionStatus"></sc-dictionary-label>
                  </div>
                  <sc-content-spacer></sc-content-spacer>
                  <div class="value">
                    <sc-dictionary-label
                    dictionaryKey="tmc-yard.ui.transport.details.dialog.positionStatus.{{rp.positionStatus}}"></sc-dictionary-label>
                  </div>
                </div>
              }
              @if (rp.actionType) {
                <div class="routing-detail">
                  <div class="label">
                    <sc-dictionary-label
                    dictionaryKey="tmc-yard.ui.transport.details.dialog.actionType"></sc-dictionary-label>
                  </div>
                  @if (rp.actionType) {
                    <sc-content-spacer></sc-content-spacer>
                  }
                  <div class="value">
                    <sc-dictionary-label
                    dictionaryKey="tmc-yard.ui.transport.details.dialog.actionType.{{rp.actionType}}"></sc-dictionary-label>
                  </div>
                </div>
              }
            </div>
            @if (rp.stationName || rp.cargo || rp.positionStatus || rp.actionType) {
              <sc-content-spacer vertical
              ></sc-content-spacer>
            }
            <div class="log-details-container">
              @for (entry of rp.LogEntryViews; track entry; let i = $index) {
                <div class="log-detail-row">
                  @if (entry.executionType) {
                    <div class="log-detail-execution-type">
                      {{entry.executionType}}
                    </div>
                  }
                  <sc-content-spacer></sc-content-spacer>
                  @if (entry.timestamp) {
                    <div class="log-detail-timestamp">
                      {{entry.timestamp}}
                    </div>
                  }
                  <sc-content-spacer></sc-content-spacer>
                  <div class="log-detail-log">
                    <div class="log-detail-log-layout">
                      @if (entry.logActivityTypeTranslated) {
                        <span>
                          {{entry.logActivityTypeTranslated}}
                        </span>
                      }
                      @if (entry.logActivityTypeTranslated && entry.text) {
                        <span> &nbsp; - &nbsp; </span>
                      }
                      @if (entry.text) {
                        <span class="log-detail-text">
                          {{entry.text}}
                        </span>
                      }
                    </div>
                  </div>
                </div>
                @if (showLogEntryKeys  && entry.hashKey) {
                  <div class="log-detail-row">
                    <sc-content-spacer grow></sc-content-spacer>
                    <span class="log-id">
                      <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.details.dialog.key"></sc-dictionary-label>{{': ' +
                    entry.hashKey}}</span>
                    <sc-content-spacer></sc-content-spacer>
                    <sc-action-icon (click)="copyLogKeyToClipboard(entry.hashKey)" iconClass="fa-copy"></sc-action-icon>
                  </div>
                }
              }
            </div>
          </div>
          <div class="log-entry-container-spacer">
            <div class="visible-container"></div>
          </div>
        }
      </div>

    </div>
  </div>

  <div class="add-note-container no-field-space">
    <div class="add-note-container-layout">
      <mat-form-field class="note-input" appearance="fill">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.details.dialog.protocol.note"></sc-dictionary-label>
        </mat-label>
        <input matInput [(ngModel)]="noteModel" name="orderReference" #orderReferenceCtrl="ngModel"
          [maxlength]="255" [disabled]="loading">
        </mat-form-field>
        <sc-content-spacer></sc-content-spacer>
        <button mat-stroked-button (click)="addNote()"
          [disabled]="loading || this.routingPositions.length === 0 || this.noteModel.length === 0">
          <sc-dictionary-label
          dictionaryKey="tmc-yard.ui.transport.details.dialog.protocol.action.addNote"></sc-dictionary-label>
        </button>
      </div>
    </div>
  </div>
